export const iconFontAwesomeArrowsClockRotateLeft = (
	<i className="fa-solid fa-clock-rotate-left"></i>
);
